import { store } from './store';
import { createLogData, Logger, LogLevelType, LogOptions } from '@workday/upc-common';
import { accountApiSlice } from './slices/account-api.slice';
import { environment } from '../environments/environment';

let loggingEnabled = environment.enableLogging;

const dispatchLog = (level: LogLevelType, options: LogOptions) => {
    if (loggingEnabled) {
        store.dispatch<any>(accountApiSlice.endpoints.sendLog.initiate(createLogData(level, options)));
    }
};

export const logger: Logger = {
    trace: options => dispatchLog('Trace', options),
    debug: options => dispatchLog('Debug', options),
    info: options => dispatchLog('Info', options),
    warn: options => dispatchLog('Warn', options),
    error: options => dispatchLog('Error', options),
    stats: options => {
        if (loggingEnabled) {
            store.dispatch<any>(accountApiSlice.endpoints.sendSessionStats.initiate(options));
        }
    },
    metric: options => {
        if (loggingEnabled) {
            store.dispatch<any>(accountApiSlice.endpoints.sendMetric.initiate(options));
        }
    },
    setEnabled: enabled => {
        loggingEnabled = enabled;
    }
};
